export default __webpack_public_path__ + "8362a38b9b84cae10c6f21f5134e4723.png";